/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Input, Modal } from "antd";
import React, { useCallback } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";

export default React.memo(
  (props: {
    suffix: boolean;
    suffixChange: () => void;
    getSuffix: (suffix: string) => void;
  }) => {
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();
    const { suffix, suffixChange, getSuffix } = props;

    const onCancel = useCallback(() => {
      suffixChange();
      form.resetFields();
    }, [suffixChange, form]);

    const addSuffix = useCallback(async () => {
      const emailSuffix = await form.validateFields();
      await getSuffix(emailSuffix.emailSuffix);
      suffixChange();
      form.resetFields();
    }, [form, getSuffix, suffixChange]);

    return (
      <Modal footer={""} visible={suffix} onCancel={onCancel}>
        <Form layout="vertical" form={form}>
          <Form.Item
            label={formatMessage(messageIds.company.addSuffix)}
            name="emailSuffix"
            rules={[
              {
                required: true,
                message: formatMessage(messageIds.company.validate.inputSuffix),
              },
              {
                pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: formatMessage(messageIds.company.validate.suffixErr),
                validateTrigger: "blur",
              },
            ]}
          >
            <Input addonBefore="@"></Input>
          </Form.Item>
          <div
            css={css`
              text-align: right;
            `}
          >
            <Button
              css={css`
                height: 32px;
                min-width: 88px;
                border-radius: 4px;
              `}
              onClick={onCancel}
            >
              {formatMessage(messageIds.common.cancel)}
            </Button>
            <Button
              type="primary"
              css={css`
                height: 32px;
                min-width: 88px;
                border-radius: 4px;
                margin-left: 20px;
              `}
              onClick={addSuffix}
            >
              {formatMessage(messageIds.common.confirm)}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
